export const formatProfiles = (profiles) => {

    if(profiles[0]?.hitsContainers[0]?.hits){

        return profiles[0].hitsContainers[0].hits.map((profile) => {
            return {
            id: profile.resource.displayName,
            label: profile.resource.displayName,
            value: profile.resource.userPrincipalName,
            };
        });
    }else{
        return [{
            id: "No User Found",
            label: "No User Found",
            value: "No User Found",
        }]
    }
    // return profiles.map((profile) => {
    //     // if(profile.userPrincipalName)
    //     return {
    //     id: profile.userPrincipalName,
    //     label: profile.displayName,
    //     value: profile.userPrincipalName,
    //     };
    // });
}